const getVariableFromString = (defaultValue: string | undefined) => {
  const regex = /\${(.*?)}/;
  const match = defaultValue?.match(regex);

  if (!match) {
    return null;
  }

  return match[1];
};

export default getVariableFromString;
